<template>
    <div class="ui button no border"
        @click="action_core_waybill()"
        :class="[
            {
                'loading': is_processing,
            },
            active_button_color || 'blue'
        ]">
        {{ active_button_content || $t('ui.general.update') }}
    </div>
</template>

<script>
export default {
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
        eventbus: {
            default: {
                change_current_template: {
                    name: "",
                },
                file_uploader: {
                    name: "",
                },
                update_core_waybill: {
                    name: "",
                },
                print_label: {
                    name: "",
                },
            },
            type: Object,
        },
        /*
         * active button options
         */
        active_button_color: {
            default: "blue",
            type: String
        },
        active_button_content: {
            default: "更新",
            type: String
        },
        active_button_channel: {
            default: "",
            type: String
        },
    },
    data() {
        return {
            is_processing: false,
            is_update_enable: true,
        }
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        action_core_waybill() {
            this.is_update_enable = true
            if (this.active_button_channel != '') {
                this.$bus.$emit(this.active_button_channel)

            } else {
                this.$bus.$emit(this.eventbus.update_core_waybill.name)

                // this.chech_related_columns()
                // if (this.is_update_enable) {
                //     this.update_core_waybill()
                // } else {
                //     alert("請更新必填欄位")
                //     this.$noty.error('請更新必填欄位')
                // }
            }
        },
        /*
         * This action for simple_form == true use
         * And no props button_channel
         */
        chech_related_columns() {
            _.forEach(this.related_columns, (related_columns) => {
                if (related_columns.is_required == true) {
                    if (!this.core_waybill[related_columns.name]) {
                        this.is_update_enable = false
                    }
                }
            })
        },
        update_core_waybill() {
            this.is_processing = true
            // Prepare parameters
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybill_update).parse(
                {
                    "core_waybill_identity": this.core_waybill.identity,
                }
            )

            axios.post(url, this.core_waybill, {
                headers: { Authorization: localStorage.getItem("authentication_token") }
            })
            .then(response => {
                if (response.data.status == "success") {
                    // this.$noty.success("運單更新成功")
                    this.$noty.success(
                        this.$t('ui.notifications.success.update__name', {
                            name: this.$t('models.core_waybills')
                        })
                    )
                } else {
                    console.log(response.data)
                    // this.$noty.error("運單更新失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.update__name', {
                            name: this.$t('models.core_waybills'),
                        })
                    )
                }
                this.is_processing = false
            })
            .catch(error => {
                console.log(error)
                if (!error.response) {
                    // Network Error
                    this.$noty.error(
                        this.$t('ui.general.network_abnormality')+": "+
                        this.$t('ui.general.server_offline')
                    )
                } else {
                    this.$noty.error(
                        this.$t('ui.general.network_abnormality')+': ' +
                        error.response.status + error.response.data
                    )
                }
            })
            this.is_processing = false
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
